<script>
import FormBlock from '@/components/FormBlock.vue';

export default {
  name: 'UserDetailProjectsTile',
  components: { FormBlock },
  props: {
    user: Object,
  },
  computed: {
    allProjectsCount() {
      return this.user.projectParticipation.project.inactive + this.user.projectParticipation.project.author;
    },

    archivedProjectsCount() {
      return this.user.projectParticipation.project.inactive;
    },

    activeProjectsCount() {
      return this.user.projectParticipation.project.author;
    },
  },
};
</script>

<template lang="pug">
  FormBlock(mobile)
    .b-user-detail-projects-tile
      ._header Проекты
      ._data
        ._row
          ._title Всего:
          ._value.-total {{ allProjectsCount }}
        ._row
          ._title Активные проекты:
          ._value.-active {{ activeProjectsCount }}
        ._row
          ._title Архивные проекты:
          ._value.-archived {{ archivedProjectsCount }}
</template>

<style scoped lang="scss">
.user-detail-projects-tile {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__projects-tile-header {
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(235, 239, 242, 1);
    color: rgb(30, 49, 71);
    font-family: Geometria,sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
  }

  &__data {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    color: rgb(146, 160, 176);
    font-family: Geometria, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 1px;
    text-align: left;
  }

  &__value {
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    color: rgb(255, 255, 255);
    font-family: Geometria, sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 1;
    letter-spacing: 0;
    text-align: center;

    &--total {
      background-color: rgba(51, 161, 251, 1);
    }

    &--active {
      background-color: rgba(90, 193, 105, 1);
    }

    &--archived {
      background-color: rgba(217, 218, 218, 1);
    }
  }
}
</style>
